/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRouteTable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 2H2v20h20V2H3zm1 6V4h16v4H4zm0 2h16v4H4v-4zm0 6h16v4H4v-4zM18 5h-2v2h2V5zm-2 6h2v2h-2v-2zm2 6h-2v2h2v-2zM11 5h2v2h-2V5zm2 6h-2v2h2v-2zm-2 6h2v2h-2v-2zM8 5H6v2h2V5zm-2 6h2v2H6v-2zm2 6H6v2h2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRouteTable as RouteTable };
